import { combineEpics } from 'redux-observable';
import authEpic from './authEpic'
import vehicleEpic from './vehicleEpic'

const rootEpic = combineEpics(

    // Register User Epic
    authEpic.registerUser,

    // Account Activate
    authEpic.activateAccountConfirm,

    authEpic.resendActivationLink,

    // Api Auth Token Epic
    authEpic.apiTokenAuth,

    // Social Token Auth Epic
    authEpic.socialApiAuth,

    // Password Reset
    authEpic.passwordReset,

    // Password Reset Confirm
    authEpic.passwordResetConfirm,

    // API Auth Token Destroy Epic
    authEpic.apiTokenLogout,

    // Get Download File
    authEpic.getDownloadFile,

    // Update Training Progress
    authEpic.updateTrainingProgress,
    
    // Get User Profile Epic
    authEpic.getUserProfile,

    // Upgrade to Agent Account
    authEpic.upgradeToAgentAccount,

    // Get Agent Profile Epic
    authEpic.getAgentProfile,

    // Get User Orders Epic
    authEpic.getUserOrders,

    // Get User Basket Epic
    authEpic.getUserBasket,

    // Get Shipping Quote Epic
    authEpic.getShippingQuote,

    // Apply discount code Epic
    authEpic.discountCodeApplication,

    // Get Vehicle Make Count Epic
    vehicleEpic.getVehicleMakeCount,

    // Search Vehicle Epic
    vehicleEpic.searchVehicle,

    // Search Item
    vehicleEpic.searchItem,

    // Get Products
    vehicleEpic.getProducts,

    // Get Item
    vehicleEpic.getItem,

    // Get Countries
    vehicleEpic.getCountries,

    // Get Specifications
    vehicleEpic.getSpecifications,

    // Get Price
    vehicleEpic.getPrice,

    // Get Stock Record
    vehicleEpic.getStockRecord,
    
    // Add Product To Basket
    vehicleEpic.addProductToBasket,

    // Place Order
    vehicleEpic.placeOrder,
    
    // // Get Best Deals
    // vehicleEpic.getBestDeals,

    // Get Promotional Api Data
    vehicleEpic.getPromotionalApiData,

    // Get Vehicle Details
    vehicleEpic.getVehicle,

    // Get shipping methods API data
    vehicleEpic.getShippingMethods,
);

export default rootEpic;